import createCustomers from '@/views/customers'

import { storage } from '@/services/storage'

var routes = [
    {
        path: '/customers/:type?',
        name: 'customers',
        component: createCustomers,
        props: true,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Novo Cliente',
            protect: true,
            iframe: true
        },
    }
]

export { routes }